import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选综艺主题策划，发现更多精彩内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-200 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                <h3 className="text-base md:text-lg font-heading font-bold mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-white/80 mb-2">{item.subtitle}</p>
                <p className="text-xs text-white/70 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}